import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useMemo, useState } from 'react';
import PopoverButton from '../../common/controls/popoverButton';
import entityComposition from '../../common/classes/entityComposition';
import { valueSelector } from '../selectors';
const AddFromOptionsButton = _ref => {
  let enabled = _ref.enabled,
    _ref$groupedOptions = _ref.groupedOptions,
    groupedOptions = _ref$groupedOptions === void 0 ? [] : _ref$groupedOptions,
    _ref$optionsExclusion = _ref.optionsExclusionKey,
    optionsExclusionKey = _ref$optionsExclusion === void 0 ? '' : _ref$optionsExclusion,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? 'missing' : _ref$testingIdentifie,
    title = _ref.title,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    onAdd = _ref.onAdd;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  const filteredGroupOptions = useMemo(() => {
    const updatedOptions = [];
    const valuesToExclude = value ? Object.keys(value).map(key => value[key][optionsExclusionKey]) : [];
    groupedOptions.forEach(go => {
      if (go.label) {
        updatedOptions.push({
          groupLabel: go.label
        });
      }
      // each group has children
      go.children.forEach(c => {
        if (!valuesToExclude.includes(c[optionsExclusionKey])) {
          updatedOptions.push({
            id: c[optionsExclusionKey],
            name: c.title
          });
        }
      });
    });
    return updatedOptions;
  }, [groupedOptions, optionsExclusionKey, value]);
  const handleToggle = () => setOpen(!open);
  const handleAdd = item => {
    const itemToAdd = {
      title: item.name,
      identifier: item.id
    };
    onAdd(null, itemToAdd);
    setOpen(false);
  };
  return /*#__PURE__*/React.createElement(PopoverButton, {
    enabled: enabled,
    header: false,
    isOpen: open,
    list: filteredGroupOptions,
    onSelect: handleAdd,
    onToggle: handleToggle,
    title: title,
    testingIdentifier: testingIdentifier,
    className: "btn-block tqc-control"
  });
};
AddFromOptionsButton.propTypes = {
  enabled: PropTypes.bool.isRequired,
  groupedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  onAdd: PropTypes.func.isRequired,
  optionsExclusionKey: PropTypes.string,
  testingIdentifier: PropTypes.string,
  title: PropTypes.string.isRequired,
  value: PropTypes.shape({})
};
export { AddFromOptionsButton as UncomposedAddFromOptionsButton };
export default entityComposition(AddFromOptionsButton, [], {
  value: valueSelector
});